import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IBannerProduct extends IEntity {
  attributes: {
    id: EntityStringId;
    product: string;
    subscriptionTypes: string[];
    subscriptionStates: string[];
  };
}

export type BannerProduct = Entity<IBannerProduct>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BannerProduct: IEntityType<IBannerProduct> = vmClient.defineClass({
  typeName: 'BannerProduct',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    product: {
      type: 'string',
      notNull: true,
    },
    subscriptionTypes: {
      type: 'string',
      collection: true,
      notNull: true,
    },
    subscriptionStates: {
      type: 'string',
      collection: true,
      notNull: true,
    },
  },
});
